module.exports = __webpack_public_path__ + "static/img/meizhuanghufu.a9e2441.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meizhuanghufu.png
// module id = 0NDm
// module chunks = 0